@import '~swiper/swiper.min.css';
@import '~swiper/modules/navigation/navigation.min.css';

:host {
  display: block;
}

.swiper,
.swiper-fix,
.swiper-five {
  --swiper-background-color: inherit;
  overflow: hidden;

  &.swiper-product {
    font-family: var(--primary-font);
    position: relative;
    width: 100%;
    max-width: 1400px;
    height: auto;
    margin: 0 auto;
    padding-top: 50px;
    padding-bottom: 75px;

    @include breakpointMin('md') {
      padding-bottom: 50px;
    }

    @include breakpointMin('lg') {
      padding-bottom: 110px;
    }
  }

  .swiper-slide {
    padding-left: 5px;
    padding-right: 5px;
    background: var(--color-white);
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    overflow: visible !important;
    height: auto;

    @include breakpointMin('md') {
      padding-left: 10px;
      padding-right: 10px;
    }

    img {
      display: block;
    }
  }

  .swiper-navigation {
    position: absolute;
    bottom: 0;
    left: 50%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    transform: translate(-50%, 0);
    z-index: 2;

    @include breakpointMin('md') {
      position: absolute;
      top: 5px;
      right: 0;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 150px;
      transform: inherit;
      left: initial;
      bottom: initial;
    }

    .swiper-pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      bottom: 15px;
    }

    .swiper-button-next {
      &:after {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        background: var(--color-bleached-silk);
        border-radius: 50px;
        color: var(--color-nero);
      }
    }

    .swiper-button-prev {
      &:after {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        background: var(--color-bleached-silk);
        border-radius: 50px;
        color: var(--color-nero);
      }
    }
  }

  &-link {
    position: absolute;
    left: 10px;
    top: 20px;
    width: 100%;
    text-align: center;

    @include breakpointMin('md') {
      width: auto;
      text-align: left;
    }
  }

  lilu-hr {
    padding-left: 5px;
    padding-right: 5px;
    max-width: 1400px;
    margin: 0 auto;

    @include breakpointMin('md') {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  lilu-fix-product-tile {
    height: 100%;
    --backdrop-color: var(--swiper-background-color);

    &.fixed-overlay {
      width: calc(33.3% + 1px);
      padding: 17px 10px 100px 10px;

      @include breakpointMin('lg') {
        padding-bottom: 160px;
      }

      @media screen and (min-width: 1200px) {
        width: calc(25% + 1px);
      }

      position: absolute;
      @include layerIndex('second');

      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;

      @include breakpointMax('md') {
        z-index: -1;
      }

    }
  }
}

lilu-product-tile.skeleton-tile {
  width: 100%;
  margin-top: -10px;
}
